<template>
   <div :class="alertClass" role="alert">
      <slot></slot>
   </div>
</template>

<script>
export default {
   name: "Alert",
   props: {
      dismissable: { 
         type: Boolean,
         default: false
      },
      color: {
         type: String,
         default: 'danger',
         validator: function(value){
            return ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'].indexOf(value) !== -1;
         }
      }
   },
   computed: {
      alertClass(){
         return `alert alert-${this.color} text-left`;
      }
   }
}
</script>